import React from "react";

export interface UseCloseAnimationOptions {
  defaultState?: boolean;
  animationDuration?: number;
}

export interface UseCloseAnimationReturn {
  isVisible: boolean;
}

export const useCloseAnimationTimeout = (
  isOpen: boolean,
  options?: UseCloseAnimationOptions
) => {
  const [isVisible, setIsVisible] = React.useState(
    options?.defaultState || false
  );

  React.useEffect(() => {
    let timeout: NodeJS.Timeout | undefined = undefined;
    if (isOpen) {
      setIsVisible(true);
    } else {
      timeout = setTimeout(() => {
        setIsVisible(false);
      }, options?.animationDuration || 100);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [isOpen]);

  return { isVisible };
};
